import React, { useState } from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const fieldOptions = [
  {
    label: 'Market Share of Retail Sales',
    id: 'retailSales',
    fieldName: 'retailSales',
    marketShareKey: ['retailSales_sum_value', 'retailSales_sum_value']
  },
  {
    label: '1P Market Share of Retail Sales',
    id: 'onePSales/retailSales',
    fieldName: 'onePSales',
    marketShareKey: ['onePSales_sum_value', 'retailSales_sum_value']
  },
  {
    label: '1P Market Share of 1P Retail Sales',
    id: 'onePSales/onePRetailSales',
    fieldName: 'onePSales',
    marketShareKey: ['onePSales_sum_value', 'onePSales_sum_value']
  },
  {
    label: '3P Market Share of Retail Sales',
    id: 'threePSales',
    fieldName: 'threePSales',
    marketShareKey: ['threePSales_sum_value', 'retailSales_sum_value']
  },
  {
    label: '3P Market Share of 3P Retail Sales',
    id: 'threePSales/threePSales',
    fieldName: 'threePSales',
    marketShareKey: ['threePSales_sum_value', 'threePSales_sum_value']
  }
];

const AtlasV2SalesMarketShareOfMultipleSelectSplineChart = () => {
  const [selectedFieldName, setSelectedFieldName] = useState('retailSales');

  const defaultFieldObj = fieldOptions.find((option) => option.id === selectedFieldName);

  return (
    <AtlasV2ComparableSplineChart
      fieldName={defaultFieldObj.fieldName}
      indexName="sales"
      metricTypeDisplay={METRICTYPE.PERCENT}
      singleDropdownProps={{
        defaultLabel: 'Market Share of Retail Sales',
        options: fieldOptions,
        selectedId: selectedFieldName,
        onChange: (option) => {
          setSelectedFieldName(option.id);
        }
      }}
      marketShareKey={defaultFieldObj.marketShareKey}
      marketShareBuilder={(rb) => {
        switch (selectedFieldName) {
          case 'retailSales':
          case 'threePSales/threePSales':
            return rb.removeConditionTermFilters((termFilter) => termFilter.fieldName === 'brandId');

          case 'onePSales/retailSales':
          case 'threePSales':
            return rb
              .modifyAggregation((agg) =>
                agg.removeAggregationField('onePSales').addAggregationField('retailSales', 'retailSales', 'sum', true)
              )
              .removeConditionTermFilters((termFilter) => termFilter.fieldName === 'brandId');
          case 'onePSales/onePRetailSales':
            return rb
              .modifyAggregation((agg) =>
                agg.removeAggregationField('retailSales').addAggregationField('One P Sales', 'onePSales', 'sum', true)
              )
              .removeConditionTermFilters((termFilter) => termFilter.fieldName === 'brandId');
          default:
            break;
        }

        return rb;
      }}
    />
  );
};

export default AtlasV2SalesMarketShareOfMultipleSelectSplineChart;
